<template>
  <div class="ut-container-lg ut-relative">
    <select-list
      v-if="isPrincipal && agentFilterList.length > 1"
      :options="agentFilterList"
      v-model="selectedAgent"
      class="agent-filter"
      @input="updateAgentFilter"
    />
    <tabs @changeTabs="changeTabs" gacategory="Leads">
      <tab
        name="Open"
        :selected="true">
        <div v-if="hasRequiredAttentionLams">
          <h2 class="ut-text-xl ut-font-semibold ut-mb-6">
            Requires attention
          </h2>
          <leads-activity-section
            class="ut-mb-8"
            :ak="ak"
            :leadActivities="attentionLams"
            :type="'Attention'"
            :stateName="'Open'"
            :isLoading="loadingMoreLams"
            @load-more-activities="getMoreLams"
            gacategory="Leads"
          />
          <h2 class="ut-text-xl ut-font-semibold ut-mb-6">
            Open leads
          </h2>
        </div>

        <leads-activity-section
          :ak="ak"
          :leadActivities="openLams"
          :type="'Normal'"
          :stateName="'Open'"
          :isLoading="loadingMoreLams"
          @load-more-activities="getMoreLams"
        />

      </tab>

      <tab name="On hold">
        <leads-activity-section
          :ak="ak"
          :leadActivities="onHoldLams"
          :type="'All'"
          :stateName="'On Hold'"
          :isLoading="loadingMoreLams"
          @load-more-activities="getMoreLams"
          gacategory="Leads"
        />
      </tab>

      <tab name="Won">
        <leads-activity-section
          :ak="ak"
          :leadActivities="wonLams"
          :type="'All'"
          :stateName="'Won'"
          :isLoading="loadingMoreLams"
          @load-more-activities="getMoreLams"
          gacategory="Leads"
        />
      </tab>

      <tab name="Lost">
        <leads-activity-section
          :ak="ak"
          :leadActivities="lostLams"
          :stateName="'Lost'"
          :isLoading="loadingMoreLams"
          @load-more-activities="getMoreLams"
          gacategory="Leads"
        />
      </tab>

      <tab name="Closed">
        <leads-activity-section
          :ak="ak"
          :leadActivities="closedLams"
          :stateName="'Closed'"
          :isLoading="loadingMoreLams"
          @load-more-activities="getMoreLams"
          gacategory="Leads"
        />
      </tab>
    </tabs>
  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Tab from '@oa-vue/tab/Tab.vue';
import Tabs from '@/components/LeadTabs.vue';
import LeadsActivitySection from '@/components/LeadsActivitySection.vue';
import SelectList from '@/components/Forms/SelectList.vue';

export default {
  name: 'PremierLeadsList',
  components: {
    LeadsActivitySection,
    Tabs,
    Tab,
    SelectList,
  },
  props: {
    ak: String,
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
      attentionLams: state => state.premierLeadsListStore.attentionLeadsList,
      openLams: state => state.premierLeadsListStore.openLeadsList,
      onHoldLams: state => state.premierLeadsListStore.onHoldLeadsList,
      wonLams: state => state.premierLeadsListStore.wonLeadsList,
      lostLams: state => state.premierLeadsListStore.lostLeadsList,
      closedLams: state => state.premierLeadsListStore.closedLeadsList,
      agentsForPrincipal: state => state.principalStore.agentsForPrincipal,
    }),
    ...mapGetters('userStore', [
      'isPrincipal',
    ]),
    ...mapGetters('principalStore', [
      'agentFilterList',
    ]),
    hasRequiredAttentionLams() {
      return this.attentionLams
        && this.attentionLams.total
        && this.attentionLams.total > 0;
    },
  },
  created() {
    if (this.isPrincipal) {
      if (this.agentsForPrincipal.length === 0) {
        this.loadAgentsForPrincipal(this.user.key).then(() => {
          if (this.$route.query.agent) {
            this.updateAgentFilter(this.$route.query.agent);
          } else {
            this.updateAgentFilter(null);
          }
        });
      } else if (this.$route.query.agent) {
        this.updateAgentFilter(this.$route.query.agent);
      } else {
        this.updateAgentFilter(null);
      }
    } else if (!this.openLams || this.openLams.length === 0) {
      this.getLams('Open', 'Both');
    }
  },
  data() {
    return {
      loadingMoreLams: false,
      selectedAgent: null,
      activeTab: 'Open',
    };
  },
  methods: {
    ...mapActions('premierLeadsListStore', [
      'loadPremierLeadsList',
      'loadMoreLeadsList',
      'clearLeadsList',
    ]),
    ...mapActions('principalStore', [
      'loadAgentsForPrincipal',
    ]),
    getLams(status, leadMode = 'All') {
      const payload = {
        userKey: this.user.key, statusFilter: status, leadMode,
      };

      payload.agentKey = this.selectedAgent;

      this.loadingMoreLams = true;
      this.loadPremierLeadsList(payload).then(() => {
        this.loadingMoreLams = false;
      });
    },
    getMoreLams(payload) {
      const data = payload.data;
      data.userKey = this.user.key;

      // Make sure we get only the currently slected Agents leads
      data.agentKey = this.selectedAgent;

      this.loadingMoreLams = true;
      this.loadMoreLeadsList(data).then(() => {
        this.loadingMoreLams = false;
      });
    },
    updateAgentFilter(value) {
      this.selectedAgent = value;

      this.agentFilterList.forEach((option) => {
        if (option.value === value) {
          if (!option.selected) {
            this.clearLeadsList().then(() => {
              if (this.activeTab === 'Open') {
                this.getLams(this.activeTab, 'Both');
              } else {
                this.getLams(this.activeTab);
              }
            });
          }
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    },
    changeTabs(activeTab) {
      this.activeTab = activeTab;
      if (activeTab === 'Won' && (!this.wonLams || this.wonLams.length === 0)) {
        this.getLams('Won');
      } else if (activeTab === 'On hold' && (!this.onHoldLams || this.onHoldLams.length === 0)) {
        this.getLams('OnHold');
      } else if (activeTab === 'Lost' && (!this.lostLams || this.lostLams.length === 0)) {
        this.getLams('Lost');
      } else if (activeTab === 'Closed' && (!this.closedLams || this.closedLams.length === 0)) {
        this.getLams('Closed');
      } else if (activeTab === 'Open' && (!this.openLams || this.openLams.length === 0)) {
        this.getLams('Open', 'All');
      }
    },
  },
};

</script>

<style scoped lang="scss">
  .agent-filter {
    @apply ut-text-right ut-mb-4;
  }

</style>
